import { render, staticRenderFns } from "./CancelarSelosOs.vue?vue&type=template&id=1be25e0e&scoped=true&"
import script from "./CancelarSelosOs.vue?vue&type=script&lang=js&"
export * from "./CancelarSelosOs.vue?vue&type=script&lang=js&"
import style0 from "./CancelarSelosOs.vue?vue&type=style&index=0&id=1be25e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be25e0e",
  null
  
)

export default component.exports